import React, { useState, useEffect } from 'react'
import { SMALL_DESKTOP, LARGE_DESKTOP, MEDIUM_DESKTOP } from '../constants'
import Slider from '@material-ui/core/Slider'
import 'katex/dist/katex.min.css'

function SliderDynamicComponent(props) {
  const {
    mcData,
    completed,
    isActive,
    onAttemptChange,
    onValueChange,
    defaultValue,
    explanationClick,
    onExplanationVisible,
    isVerifyMode,
    handleSuccessChange,
    timerEnd,
    isEmbeded,
    followTheFlow,
    currentPriority,
    onPriorityChange,
    sequenceMessage,
    isPractice,
    handleSucAndFailFeedback,
    initial
  } = props
  const {
    ControlID,
    Answers,
    MinValue,
    MaxValue,
    Type,
    MinRange,
    MaxRange,
    Score,
    AnswerColorFill,
    StepCount,
    AnswerFontSize,
    AnswerFillColor,
    SelectionColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    Priority,
    Bold,
    Italic,
    FontStyle,
    SequenceHint,
    StartValue,
    LabelStep
  } = mcData

  const [value, setValue] = useState(0)
  const [incrementFactorArray, setIncrementFactorArray] = useState([])
  const [labelValue, setLabelValue] = useState([])
  const [onBlurCall, setOnBlurCall] = useState(true)
  const [sliderAttend, setSliderAttend] = useState(false)

  useEffect(() => {
    if (initial) {
      setOnBlurCall(true)
    }
  }, [initial])

  useEffect(() => {
    //  if (onBlurCall) {
    if (defaultValue) {
      if (defaultValue.CtlValue) {
        let defaultValueSelected = defaultValue.CtlValue
        setValue(defaultValueSelected)
        setSliderAttend(true)
      }
    } else {
      if (StartValue !== undefined) {
        setValue(StartValue)
      } else {
        setValue(MinValue)
      }
    }
    setOnBlurCall(false)
    // }
  }, [defaultValue])

  useEffect(() => {
    let incrementFactorArrayCopy = [...incrementFactorArray]

    let val = MinValue
    for (let index = MinValue; index < MaxValue; index++) {
      val = val + StepCount
      if (val <= MaxValue) {
        incrementFactorArrayCopy.push(Math.round(val))
      } else {
        break
      }
    }
    let labelValueCopy = []
    labelValueCopy.push({ value: MinValue, label: MinValue })
    for (let index = 0; index < incrementFactorArrayCopy.length - 1; index++) {
      if (incrementFactorArrayCopy[index] % LabelStep === 0) {
        labelValueCopy.push({
          value: incrementFactorArrayCopy[index],
          label: incrementFactorArrayCopy[index].toString()
        })
      } else {
        labelValueCopy.push({
          value: incrementFactorArrayCopy[index]
          // label: incrementFactorArrayCopy[index].toString(),
        })
      }
    }
    labelValueCopy.push({ value: MaxValue, label: MaxValue })

    setLabelValue(labelValueCopy)
    setIncrementFactorArray(incrementFactorArrayCopy)
  }, [])

  useEffect(() => {
    if (followTheFlow && currentPriority) {
      if (currentPriority === Priority) {
        sequenceMessage(SequenceHint)
      }
    }
  }, [currentPriority])

  useEffect(() => {
    let x1 = document.styleSheets[0]
    x1.addRule(
      '.MuiSlider-markLabel',
      'color:' + AnswerColorFill + '!important'
    )
    x1.addRule('.MuiSlider-thumb', 'color:' + SelectionColor + '!important')
    x1.addRule('.MuiSlider-thumb', 'height:' + '20px' + '!important')
    x1.addRule('.MuiSlider-thumb', 'width:' + '20px' + '!important')
    x1.addRule('.MuiSlider-thumb', 'border: #ffc42d 5px solid !important')
    x1.addRule('.MuiSlider-thumb', 'margin-top:' + '-10px' + '!important')

    x1.addRule('.MuiSlider-track', 'height:' + '5px' + '!important')
    x1.addRule('.MuiSlider-track', 'border-radius:' + '10px' + '!important')
    x1.addRule('.MuiSlider-rail', 'height:' + '5px' + '!important')
    x1.addRule('.MuiSlider-rail', 'border-radius:' + '10px' + '!important')

    x1.addRule(
      '.MuiSlider-valueLabel',
      'color:' + SelectionColor + '!important'
    )
    x1.addRule('.MuiSlider-root', 'color:' + SelectionColor + '!important')
    if (Bold === 'True') {
      x1.addRule('.MuiSlider-markLabel', 'font-weight:bold !important')
    }
    if (Italic === 'True') {
      x1.addRule('.MuiSlider-markLabel', 'font-style:italic !important')
    }
    x1.addRule(
      '.MuiSlider-markLabel',
      'font-family:' + FontStyle + '!important'
    )

    if (AnswerFontSize === 'SMALL') {
      x1.addRule(
        '.MuiSlider-markLabel',
        'font-size:' + SMALL_DESKTOP + '!important'
      )
    } else if (AnswerFontSize === 'LARGE') {
      x1.addRule(
        '.MuiSlider-markLabel',
        'font-size:' + LARGE_DESKTOP + '!important'
      )
    } else {
      x1.addRule(
        '.MuiSlider-markLabel',
        'font-size:' + MEDIUM_DESKTOP + '!important'
      )
    }
    x1.addRule('.MuiSlider-rail', 'color:' + SelectionColor + '!important')
    x1.addRule('.MuiSlider-rail', 'height:' + '20%' + '!important')
    x1.addRule('.MuiSlider-track', 'color:' + SelectionColor + '!important')
    x1.addRule('.MuiSlider-track', 'height:' + '20%' + '!important')
    x1.addRule(
      '.MuiSlider-trackInverted',
      'color:' + SelectionColor + '!important'
    )
    x1.addRule('.MuiSlider-mark', 'height:' + '60%' + '!important')
    x1.addRule('.MuiSlider-mark', 'width:' + '1px' + '!important')
    x1.addRule('.MuiSlider-mark', 'background-color:' + '#000' + '!important')
  }, [])

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true, value)
    }
  }, [timerEnd])

  useEffect(() => {
    if (explanationClick && !isEmbeded) {
      explanationValidation()
    }
  }, [explanationClick])

  function explanationValidation() {
    if (Type === 'exactMatch') {
      if (value === Answers) {
        onExplanationVisible(true, CorrectAnswerExplanation)
      } else {
        onExplanationVisible(false, IncorrectAnswerExplanation)
      }
    } else if (Type === 'range') {
      if (value >= MinRange && value <= MaxRange) {
        onExplanationVisible(true, CorrectAnswerExplanation)
      } else {
        onExplanationVisible(false, IncorrectAnswerExplanation)
      }
    }
  }

  function validateAnswer() {
    let isCorrect = false
    if (sliderAttend) {
      if (Type === 'exactMatch') {
        if (value === Answers) {
          isCorrect = true
        } else {
          isCorrect = false
        }
      } else if (Type === 'range') {
        if (value >= MinRange && value <= MaxRange) {
          isCorrect = true
        } else {
          isCorrect = false
        }
      }
    }
    return isCorrect
  }

  function validateCorrectAnswer(timerValue, newValue) {
    //Change priority value
    if (onPriorityChange && followTheFlow) {
      if (isPractice) {
        if (Type === 'exactMatch') {
          if (newValue === Answers) {
            onPriorityChange(Priority)
          }
        } else if (Type === 'range') {
          if (newValue >= MinRange && newValue <= MaxRange) {
            onPriorityChange(Priority)
          }
        }
      } else {
        onPriorityChange(Priority)
      }
    }
    if (Type === 'exactMatch') {
      if (newValue === Answers) {
        onValueChange(ControlID, newValue, Score, Score, '', timerValue)
        if (isEmbeded) {
          handleSucAndFailFeedback(true)
        }
      } else {
        onValueChange(ControlID, newValue, 0, Score, '', timerValue)
        if (isEmbeded) {
          handleSucAndFailFeedback(false)
        }
      }
    } else if (Type === 'range') {
      if (newValue >= MinRange && newValue <= MaxRange) {
        onValueChange(ControlID, newValue, Score, Score, '', timerValue)
        if (isEmbeded) {
          handleSucAndFailFeedback(true)
        }
      } else {
        onValueChange(ControlID, newValue, 0, Score, '', timerValue)
        if (isEmbeded) {
          handleSucAndFailFeedback(false)
        }
      }
    }
    setOnBlurCall(true)
  }

  const centerPoint = StartValue
  const totalValue = MaxValue - MinValue
  const currentPoint = StartValue - MinValue
  const currentPointPercent = (currentPoint / totalValue) * 100

  return (
    <div
      className='slide-comp-wrapper'
      onClick={() => {
        if (explanationClick && isEmbeded) {
          explanationValidation()
        }
      }}
      style={{ marginTop: isEmbeded ? '0px' : '2%' }}
    >
      {!isEmbeded && (
        <p
          className='muiSliderAnswerLabel'
          style={{
            color: AnswerColorFill,
            backgroundColor: AnswerFillColor,
            fontSize: LARGE_DESKTOP
          }}
        >
          {value}
        </p>
      )}

      <div
        className='muiSliderContainer'
        style={{
          height: isEmbeded ? '100%' : '20%',
          pointerEvents:
            explanationClick || completed === 1 || !isActive
              ? 'none'
              : isPractice && followTheFlow && isEmbeded
              ? validateAnswer()
                ? 'none'
                : 'auto'
              : 'auto'
        }}
      >
        <Slider
          key={'key' + ControlID}
          style={{
            width: '90%',
            zIndex: value === centerPoint ? 3 : 2
          }}
          value={value && value}
          onChange={(event, sliderValue) => {
            setValue(sliderValue)
          }}
          aria-labelledby={
            isEmbeded ? 'discrete-slider-always' : 'discrete-slider-small-steps'
          }
          step={StepCount}
          marks={labelValue}
          min={MinValue}
          max={MaxValue}
          onChangeCommitted={(event, newValue) => {
            setSliderAttend(true)
            if (Type === 'exactMatch') {
              if (newValue === Answers) {
                handleSuccessChange(true)
              } else {
                handleSuccessChange(false)
              }
            } else if (Type === 'range') {
              if (newValue >= MinRange && newValue <= MaxRange) {
                handleSuccessChange(true)
              } else {
                handleSuccessChange(false)
              }
            }
            onAttemptChange(1)
            validateCorrectAnswer(false, newValue)
          }}
          valueLabelDisplay={isEmbeded ? 'on' : 'off'}
          disabled={
            explanationClick || completed === 1 || !isActive
              ? true
              : isPractice && followTheFlow && isEmbeded
              ? validateAnswer()
                ? true
                : false
              : false
          }
          track={
            value > centerPoint
              ? 'normal'
              : value < centerPoint
              ? 'inverted'
              : false
          }
        />
        {StartValue !== undefined && (
          <div
            style={{
              display: 'flex',
              width: isEmbeded ? '100%' : '80%',
              height: '10%',
              flexDirection: 'row',
              position: 'absolute',
              top: '28%'
            }}
          >
            <div
              style={{
                width: currentPointPercent + '%',
                backgroundColor: value < centerPoint ? undefined : '#ffffff80',
                zIndex: value > centerPoint ? 2 : 0
              }}
            />
            <div
              style={{
                width: 100 - currentPointPercent + '%',
                backgroundColor: value > centerPoint ? undefined : '#ffffff80',
                zIndex: value < centerPoint ? 2 : 1
              }}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default SliderDynamicComponent
